import { useMsal } from "@azure/msal-react";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { editApproversWorkflowEndpoint, getViewAllDetailsEndpoint, reAssignToOthersEndpoint, recallPlannerEndpoint, rejectWorkflowEndpoint, reSubmitWorkflowEndpoint, sendForApprovalEndpoint, sendToLowMaterialsEndpoint } from "../../../common/endpoints";
import ActionInput from "../../../components/common/actioninput/ActionInputField";
import ButtonComponent from "../../../components/common/button/Button";
import { Loader } from "../../../components/common/Loader";
import { getPowerBIMaterialDetailsData } from "../../../redux/actions/LTPlanner/PowerBIMaterialDetailsSlice";
import { postReassignToOthers } from "../../../redux/actions/LTPlanner/ReassignToOthersSlice";
import { postRejectWorkflow } from "../../../redux/actions/LTPlanner/RejectWorkflowSlice";
import { postResubmitWorkflow } from "../../../redux/actions/LTPlanner/ResubmitWorkflowSlice";
import { postSendForApproval } from "../../../redux/actions/LTPlanner/SendForApprovalSlice";
import { postSendLowMaterials } from "../../../redux/actions/LTPlanner/SendToS4MaterialsSlice";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import LeadTimeLineGraph from "../LeadTimeLineGraph";
import TopSection from "../TopSection";
import "./AnalyticsResults.css";
import LeadtimeModel from "./LeadTimeModal";
import { ReAssignModal } from "./ReAssignModal";
import { RejectWorkFlowItem } from "./RejectWorkFlow/RejectWorkFlowItem";
import { SendForApprovalModal } from "./SendForApprovalModal";
import { SendToS4Modal } from "./SendToS4/SendToS4Modal";
import { putEditApproversWorkflow } from "../../../redux/actions/LTPlanner/EditApproversWorkflowSlice";
import { EditApproversModalNew } from "./EditApproversModalNew";
import { postRecallAPI } from "../../../redux/actions/LTPlanner/RecallSlice";


const AnalyticsResultsTab = (props) => {
  const role = localStorage.getItem("LTRole");
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const combinedObject = location?.state?.combinedObject || {};
  const { instance } = useMsal();
  const [openViewAllModal, setOpenViewAllModal] = useState(false);
  const [viewAllData, setViewAllData] = useState({});
  const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
  const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
  const [powerBIReportID, setPowerBIReportID] = useState("");
  const [inventoryValueState, setInventoryValueState] = useState("");

  const [openLineGraph, setOpenLineGraph] = useState(false);
  const [lineGraphSelectedValue, setLineGraphSelectedValue] = useState(false);

  const [confidenceLevel, setConfidenceLevel] = useState(combinedObject?.data?.recomConfidenceLevel);
  const [remarksTextArea, setRemarksTextArea] = useState("");
  const [formData, setFormData] = useState({
    LTData: combinedObject?.data?.finalLt,

    potentialImpact: combinedObject?.data?.potentialImpact,

    recommandedLT: combinedObject?.data?.finalLt,

  });
  const handleChangeConfidenceLevel = (event, newValue) => {

    const currentConfidenceLevel = event.target.value;

    setConfidenceLevel(event.target.value);
    setFormData({
      LTData: currentConfidenceLevel === "75%" ? combinedObject?.data?.likelyFinalLt || 0 : currentConfidenceLevel === "65%" ? combinedObject?.data?.lessLikelyFinalLt || 0 : combinedObject?.data?.highLikelyFinalLt || 0,

      potentialImpact: `${Math.round((Math.sqrt(Number(currentConfidenceLevel === "75%" ? combinedObject?.data?.likelyFinalLt || 0 : currentConfidenceLevel === "65%" ? combinedObject?.data?.lessLikelyFinalLt || 0 : combinedObject?.data?.highLikelyFinalLt || 0) / Number(combinedObject?.data?.purchDocType === "Y1" ? combinedObject?.data?.contractLt?.split(" ")[0] : combinedObject?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`
    })
  };



  const onChangeFinalLT = (event) => {
    const isValidNumber = /^[0-9]*$/.test(event.target.value);

    if (isValidNumber) {
      const row = combinedObject?.data;
      const currLt = Number(
        row?.purchDocType === "Y1"
          ? row?.contractLt?.split(" ")[0]
          : row?.activePirLt?.split(" ")[0]
      );

      const ratio = Math.sqrt(Number(event.target.value) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

      const inventoryChange =
        (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
        row?.currentAvgStock;

      let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);
      setInventoryValueState(inventoryValue);

      setFormData({
        ...formData,
        LTData: event.target.value,
        potentialImpact: `${Math.round((Math.sqrt(Number(event.target.value || 0) / Number(combinedObject?.data?.purchDocType === "Y1" ? combinedObject?.data?.contractLt?.split(" ")[0] : combinedObject?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`
      })
    }
  }

  const onClickSendToS4Handler = async () => {
    const userEmail = localStorage.getItem("data");

    const arrSendToS4 = [{
      "runOutputSeqId": combinedObject?.data?.runOutputSeqId,
      "userLt": formData?.LTData,
      "confidenceLevel": confidenceLevel,
      "recommendedLt": confidenceLevel === "85%" ? combinedObject?.data?.highLikelyFinalLt : formData?.recommandedLT || formData?.LTData
    }];

    const sendToS4RequestBody = {
      "userEmail": userEmail,
      "outputReviewList": arrSendToS4,
      "userRemarks": remarksTextArea
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSendtoLowMaterials = await dispatch(postSendLowMaterials({
        dynamicEndpoint: `${sendToLowMaterialsEndpoint}`,
        data: sendToS4RequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSendtoLowMaterials.meta.requestStatus === 'fulfilled') {
        toast.success(responseSendtoLowMaterials?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseSendtoLowMaterials?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }

  const onClickRejectHandler = async () => {

    const userEmail = localStorage.getItem("data");

    const arr = [{
      "runOutputSeqId": combinedObject?.data?.runOutputSeqId,
      "userLt": formData?.LTData,
      "confidenceLevel": confidenceLevel,
      "recommendedLt": confidenceLevel === "85%" ? combinedObject?.data?.highLikelyFinalLt : formData?.recommandedLT || formData?.LTData
    }]

    const rejectRequestBody = {
      "userEmail": userEmail,
      "outputReviewList": arr,
      "userRemarks": remarksTextArea
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;

    localStorage.setItem('accessToken', accessToken);
    try {
      const responseRejectWorkflow = await dispatch(postRejectWorkflow({
        dynamicEndpoint: `${rejectWorkflowEndpoint}`,
        data: rejectRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseRejectWorkflow.meta.requestStatus === 'fulfilled') {
        toast.success(responseRejectWorkflow?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseRejectWorkflow?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }


  const sendForApprovalAPI = async (approversData, comments) => {
    // console.log("Send For Approv API ", approversData, comments)
    const userEmail = localStorage.getItem("data");
    const arr = [{
      "runOutputSeqId": combinedObject?.data?.runOutputSeqId,
      "userLt": formData?.LTData,
      "confidenceLevel": confidenceLevel,
      "recommendedLt": confidenceLevel === "85%" ? combinedObject?.data?.highLikelyFinalLt : formData?.recommandedLT || formData?.LTData
    }]

    const approversList = [];
    approversData.map((item, index) => {
      approversList.push({
        "approverEmail": item.email,
        "approverName": item.name,
        "approverLevel": item.level
      },)
    })

    const sendForApprovalRequestBody = {
      "userEmail": userEmail,
      "userRemarks": comments,
      "outputReviewList": arr,
      "approversList": approversList
    }

    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSendForApproval = await dispatch(postSendForApproval({
        dynamicEndpoint: `${sendForApprovalEndpoint}`,
        data: sendForApprovalRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSendForApproval.meta.requestStatus === 'fulfilled') {
        toast.success(responseSendForApproval?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseSendForApproval?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }

  const reAssignSubmitAPI = async (selectedName, selectedEmailId, reAssignComments) => {
    const userEmail = localStorage.getItem("data");
    const reAssignArr = [];
    [combinedObject?.data]?.map((item, index) => {
      reAssignArr.push(item.runOutputSeqId)
    })

    const reAssignRequestBody = {
      "userEmail": userEmail,
      "userRemarks": reAssignComments,
      "assigneeName": selectedName,
      "assigneeEmail": selectedEmailId,
      "runOutputSeqIdList": reAssignArr
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseReassignToOthers = await dispatch(postReassignToOthers({
        dynamicEndpoint: `${reAssignToOthersEndpoint}`,
        data: reAssignRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseReassignToOthers.meta.requestStatus === 'fulfilled') {
        toast.success(responseReassignToOthers?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseReassignToOthers?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const RecallAPI = async () => {
    const userEmail = localStorage.getItem("data");
    const arr = [];
    [combinedObject?.data]?.map((item, index) => {
      arr.push({
        "runOutputSeqId": combinedObject?.data?.runOutputSeqId,
        "userLt": formData?.LTData,
        "level": 0,
        "confidenceLevel": confidenceLevel,
        "recommendedLt": confidenceLevel === "85%" ? combinedObject?.data?.highLikelyFinalLt : formData?.recommandedLT || formData?.LTData
      })
    })

    const recallRequestBody = {
      "userEmail": userEmail,
      "userRemarks": remarksTextArea,
      "updateWorkflowsList": arr
    }

    try {
      const responseRecall = await dispatch(postRecallAPI({
        dynamicEndpoint: `${recallPlannerEndpoint}`,
        data: recallRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseRecall.meta.requestStatus === 'fulfilled') {
        toast.success(responseRecall?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseRecall?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }
  const ResubmitForApprovalAPI = async () => {
    const userEmail = localStorage.getItem("data");
    const arr = [];
    [combinedObject?.data]?.map((item, index) => {
      arr.push({
        "runOutputSeqId": combinedObject?.data?.runOutputSeqId,
        "userLt": formData?.LTData,
        "level": 0,
        "confidenceLevel": confidenceLevel,
        "recommendedLt": confidenceLevel === "85%" ? combinedObject?.data?.highLikelyFinalLt : formData?.recommandedLT || formData?.LTData
      })
    })

    const reSubmitForApprovalRequestBody = {
      "userEmail": userEmail,
      "userRemarks": remarksTextArea,
      "updateWorkflowsList": arr
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);
    try {
      const responseReSubmitWorkflow = await dispatch(postResubmitWorkflow({
        dynamicEndpoint: `${reSubmitWorkflowEndpoint}`,
        data: reSubmitForApprovalRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseReSubmitWorkflow.meta.requestStatus === 'fulfilled') {
        toast.success(responseReSubmitWorkflow?.payload, {
          autoClose: 2000,
        });
        navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })
      } else {
        toast.error(responseReSubmitWorkflow?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }
  const EditApproversAPI = async (approversData) => {
    const userEmail = localStorage.getItem("data");
    const runOutputSeqId = combinedObject?.data?.runOutputSeqId;

    const approversList = [];
    approversData.map((item) => {
      approversList.push({
        "approverEmail": item.email,
        "approverName": item.name,
        "approverLevel": item.level
      },)
    })

    const editApproversRequestBody = {
      "userEmail": userEmail,
      "runOutputSeqId": runOutputSeqId,
      "approversList": approversList
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);
    try {
      const responseEditApprovers = await dispatch(putEditApproversWorkflow({
        dynamicEndpoint: `${editApproversWorkflowEndpoint}`,
        data: editApproversRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseEditApprovers.meta.requestStatus === 'fulfilled') {
        toast.success(responseEditApprovers?.payload, {
          autoClose: 2000,
        });
      } else {
        toast.error(responseEditApprovers?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }
  const getViewAllData = async (row) => {
    try {
      const responseViewAllDetails = await dispatch(getViewAllDetails({
        dynamicEndpoint: `${getViewAllDetailsEndpoint}/${combinedObject?.data?.runSeqId}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
        setViewAllData(responseViewAllDetails?.payload)
      } else {
        console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
        toast.error(responseViewAllDetails?.payload?.errorMessage, {
          autoClose: 2000,
        });
        setViewAllData({})
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }
  const handleOpenViewAllModal = (row) => {
    setOpenViewAllModal(true);
    getViewAllData(row);
  }
  const handleCloseViewAllModal = () => {
    setOpenViewAllModal(false);
    setViewAllData({})
  }

  const group_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_GROUP_ID
  const report_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_REPORT_ID;

  const filter = [
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "material_poitem",
      },
      operator: "Equals",
      values: [combinedObject?.data?.materialId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "supplier",
      },
      operator: "Equals",
      values: [combinedObject?.data?.supplierId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "plant_poitem",
      },
      operator: "Equals",
      values: [localStorage.getItem("selectedLTPlantCode")],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "LTA_JOB_RUN_ID",
      },
      operator: "Equals",
      values: [combinedObject?.data?.runSeqId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "purchasingdocumenttype",
      },
      operator: "Equals",
      values: [combinedObject?.data?.purchDocType],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "PREDOMINANT_TRANSPORT_NAME",
      },
      operator: "Equals",
      values: [combinedObject?.data?.transportMode],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    }
  ];

  const incotermFilter = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "Month",
      column: "INCOTERSLOCATION1_POITEM",
    },
    operator: "Equals",
    values: [combinedObject?.data?.incotermLocation],
    filterType: models.FilterType.Basic,
    requireSingleSelection: true
  };

  const embedConfig = {
    type: 'report',
    id: powerBIReportID,
    embedUrl: `${powerBIEmbedURL}`,
    accessToken: powerBIAccessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
    },
    filters: combinedObject?.data?.purchDocType === "YIC" ? filter : combinedObject?.data?.purchDocType === "YIP" ? filter : [...filter, incotermFilter]
  }

  useEffect(() => {
    const getPowerBIDetails = async () => {
      try {
        const responsePowerBIDetails = await dispatch(getPowerBIMaterialDetailsData({
          dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          }
        }));
        if (responsePowerBIDetails?.meta?.requestStatus === 'fulfilled') {
          setPowerBIEmbedURL(responsePowerBIDetails?.payload?.embedUrl);
          setPowerBIReportID(responsePowerBIDetails?.payload?.reportId);
          setPowerBIAccessToken(responsePowerBIDetails?.payload?.accessToken)
        } else {
          toast.error(responsePowerBIDetails?.payload?.errorMessage, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error('API error:', error);
        toast.error(error, {
          autoClose: 2000,
        });
      }
    }
    getPowerBIDetails();

  }, []);

  useEffect(() => {
    const row = combinedObject?.data;
    const finalLt = combinedObject?.data?.finalLt;

    const currLt = Number(
      row?.purchDocType === "Y1"
        ? row?.contractLt?.split(" ")[0]
        : row?.activePirLt?.split(" ")[0]
    );

    const ratio = Math.sqrt(Number(finalLt) / currLt);
    const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

    const inventoryChange =
      (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
      row?.currentAvgStock;

    let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);
    setInventoryValueState(inventoryValue)
  }, [])


  const handleCloseLineGraphModal = () => {
    setOpenLineGraph(false);
  }
  const handleSaveLineGraphModal = (row) => {
    setOpenLineGraph(false);

    const currentAvgStock = Number(combinedObject?.data?.currentAvgStock || 0);
    const oldSafetyStock = Number(combinedObject?.data?.oldSafetyStock || 0);
    const leadTime = Number(row?.leadTime || 0);
    const currLt = Number(
      combinedObject?.data?.purchDocType === "Y1"
        ? combinedObject?.data?.contractLt?.split(" ")[0]
        : combinedObject?.data?.activePirLt?.split(" ")[0]
    );

    const ratio = currLt !== 0 ? Math.sqrt(leadTime / currLt) : 0;
    const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

    const inventoryChange = (currentAvgStock - oldSafetyStock + (oldSafetyStock * ratio)) - currentAvgStock;

    let inventoryValue = (combinedObject?.data?.actualPrice * inventoryChange).toFixed(2);

    setInventoryValueState(inventoryValue)
    setFormData({
      ...formData,
      LTData: Number(row?.leadTime),
      recommandedLT: Number(row?.leadTime),
      potentialImpact: `${Math.round((Math.sqrt(Number(row?.leadTime) / Number(combinedObject?.data?.purchDocType === "Y1" ? combinedObject?.data?.contractLt?.split(" ")[0] : combinedObject?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`
    });
    setConfidenceLevel(row?.percentile)
  }

  const openConfidenceLevelGraph = () => {
    setOpenLineGraph(true);
    setLineGraphSelectedValue(combinedObject?.data)
  }

  const newSafetyStock = (() => {
    const currSafetyStock = Number(combinedObject?.data?.oldSafetyStock) || 0; /*777*/
    const newLt = Number(combinedObject?.data?.highLikelyFinalLt); /*54*/
    const oldLtValue = String(combinedObject?.data?.contractLt ?? "").trim(); /*111*/
    const oldLt = Number(oldLtValue.split(" ")[0]);
    if (!isFinite(currSafetyStock) || !isFinite(newLt) || !isFinite(oldLt) || oldLt === 0) {
      return currSafetyStock;
    }
    const result = currSafetyStock * Math.sqrt(newLt / oldLt);
    return isFinite(result) ? result : currSafetyStock;
  })();

  const newInventory = (() => {
    const currentAvgStock = Number(combinedObject?.data?.currentAvgStock) || 0;
    const currentSafetyStock = Number(combinedObject?.data?.oldSafetyStock) || 0;
    if (!isFinite(currentAvgStock) || !isFinite(currentSafetyStock) || !isFinite(newSafetyStock)) {
      return currentAvgStock;
    }
    const result = currentAvgStock - currentSafetyStock + newSafetyStock;
    return isFinite(result) ? result : currentAvgStock;
  })();

  const actualStockImpactPercent = (() => {
    const currentStock = Number(combinedObject?.data?.currentAvgStock);
    if (!isFinite(currentStock) || currentStock === 0 || !isFinite(newInventory)) {
      return 0;
    }
    const raw = ((newInventory - currentStock) / currentStock) * 100;
    const absolutePercent = Math.abs(raw);
    return isFinite(absolutePercent) ? Math.round(absolutePercent) : 0;
  })();

  const actualImpactPercent = isFinite(actualStockImpactPercent) ? `${actualStockImpactPercent}%` : "-";

  const actualInventoryImpact = (() => {
    const currentAvgStock = Number(combinedObject?.data?.currentAvgStock);
    if (!isFinite(currentAvgStock) || !isFinite(newInventory)) {
      return 0;
    }
    return newInventory - currentAvgStock;
  })();

  return (
    <div>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Analytics Results", path: "/analytics-results?fromDetails=true" },
          { title: "Results" },
        ]}
        tabTitle="Workflow Management"
      />
      <div className="analytic-results-tab">
        <div className="analytic-results-top-section">

          <div className="result-item">
            <span className="analytics-text">
              Period Consider for Analytics
            </span>
            <p>{combinedObject?.data?.periodConsidered || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Initiated by</span>
            <p>{combinedObject?.data?.ltInitiatedBy || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Run Unique ID</span>
            <p>{combinedObject?.data?.runOutputSeqId || "-"}</p>
          </div>
        </div>
        <div className="input-details">
          <p >
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={handleOpenViewAllModal}>Click Here</span>
            &nbsp;to View the Complete Input Details
          </p>
          <div>
            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
          </div>
        </div>

      </div>
      {/* <div style={{ margin: "10px 0px", textAlign: "center" }}>
        <iframe title="LTResultsupdated" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=ed64bb79-a6dd-4c23-a33a-5a41930b849e&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c&navContentPaneEnabled=false" frameborder="0" allowFullScreen="true"></iframe>
      </div> */}
      {stateSelector?.PowerBIMaterialDetailsSlice?.loading ? <Loader /> :
        <div className="powerBi_cls" style={{ marginTop: 10 }}>
          {embedConfig?.embedUrl && embedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={embedConfig}
              getEmbeddedComponent={(embedObject) => {
                window.report = embedObject;
              }}
            />}
        </div>}

      <div className="analytic-results-tab result-margin" style={{ padding: '20px 10px' }}>
        <div style={{ margin: '0px 0px 10px 10px', border: '2px solid #ccc', padding: '10px', borderRadius: '5px', maxWidth: '400px' }}>
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginBottom: '10px' }}>Potential Impact of New Lead Time on Stock : </span>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '5px'}}>
              <div style={{margin: "0px 10px 0px 10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Planned<b style={{ marginLeft: 5 }}>{formData?.potentialImpact?.replace("-", "").trim() || "-"}</b> <span>
                {
                  Number(formData?.potentialImpact?.replace("%", "").trim()) >= 0 ?
                    <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />
                }</span></span>
              </div>
              <div style={{marginLeft: "10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Actual<b style={{ marginLeft: 5 }}>{actualImpactPercent}</b>
                  <span>
                    {
                      Number(formData?.potentialImpact?.replace("%", "").trim()) >= 0 ?
                        <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />
                    }
                  </span>
                </span>
              </div>
            </div>
        </div>
        <div style={{ margin: '0px 0px 10px 10px', border: '2px solid #ccc', padding: '10px', borderRadius: '5px', maxWidth: '400px' }}>
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginBottom: '10px' }}>Potential Inventory Impact (Cost Value) : </span>
          <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '5px'}}>
            <div style={{margin: "0px 10px 0px 10px"}}>
              <span style={{ display: 'flex', alignItems: 'center' }}>Planned<b style={{ marginLeft: 5 }}>
                {combinedObject?.data?.currency === "USD" || !combinedObject?.data?.usdExchangeRate || combinedObject?.data?.usdExchangeRate === 0
                  ? `${inventoryValueState || "0.00"} ${combinedObject?.data?.currency || ""}`
                  : `${(inventoryValueState * combinedObject?.data?.usdExchangeRate).toFixed(2)} USD`}
              </b></span>
            </div>  
            <div style={{marginLeft: "10px"}}>
              <span style={{ display: 'flex', alignItems: 'center' }}>Actual
                <b style={{ marginLeft: 5 }}>
                {combinedObject?.data?.currency === "USD" || !combinedObject?.data?.usdExchangeRate || combinedObject?.data?.usdExchangeRate === 0
                  ? `${actualInventoryImpact || "0.00"} ${combinedObject?.data?.currency || ""}`
                  : `${(actualInventoryImpact * combinedObject?.data?.usdExchangeRate).toFixed(2)} USD`}
                </b>
              </span>
            </div>
          </div>
        </div>
        {(combinedObject?.activeItem === "Closed Workflow Items" || (combinedObject?.data?.currentApprovalLevel > 0))
          ?
          <div>
            <div className="recommondation_Section">
              <span id="recommondation_header">Recommendations:</span>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="analytic-results left-recommendation">
                <div>
                  <div className="result-item-rec">
                    <span>
                      % of orders with lower than recommended lead time
                    </span>
                    <p>: {confidenceLevel}</p>
                  </div>

                  <div className="result-item-rec">
                    <span>
                      Mode of Transport Considered for Recommendation
                    </span>
                    <p>: {combinedObject?.data?.transModeConsidered}</p>
                  </div>
                  <div className="result-item-rec">
                    <span>
                      Recommended LT to be Updated in S/4 (Planned)
                    </span>
                    <p>: {formData.LTData}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <div>
            <div className="recommondation_Section">
              <span id="recommondation_header">Recommendations:</span>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="analytic-results left-recommendation">
                <div>
                  <div className="result-item-rec">
                    <span>
                      % of orders with lower than recommended lead time
                    </span>
                    <p>: <span style={{ textDecoration: 'underline' }} onClick={openConfidenceLevelGraph}>{confidenceLevel}</span></p>
                  </div>
                  <div className="result-item-rec">
                    <span>
                      Mode of Transport Considered for Recommendation
                    </span>
                    <p>: {combinedObject?.data?.transModeConsidered}</p>
                  </div>
                </div>
              </div>
              <div className="right-recommendation">
                <div className="result-item" style={{ marginBottom: '10px', marginTop: 0 }}>
                  <span style={{ marginBottom: 5 }}>
                    Recommended LT to be Updated in S/4
                  </span>
                  <ActionInput
                    name="finalLT"
                    props={{ height: "35px", maxWidth: "250px" }}
                    value={formData?.LTData}
                    borderRadius="5px"
                    width="246px"
                    onChange={onChangeFinalLT}
                    disabled={role === "Admin" || combinedObject?.activeItem === "Closed Workflow Items" || (combinedObject?.data?.currentApprovalLevel > 0)}
                  />
                  <span id="helperText">Note: Please enter only numbers</span>
                </div>
                <div className="result-item" style={{ margin: '10px 0px' }}>
                  <span style={{ marginBottom: 5 }}>
                    Remarks for Acceptance/ Rejection
                  </span>
                  <ActionInput
                    className="text-input"
                    props={{ height: "35px", maxWidth: "250px" }}
                    value={remarksTextArea}
                    onChange={(e) => setRemarksTextArea(e.target.value)}
                    disabled={role === "Admin" || combinedObject?.activeItem === "Closed Workflow Items" || (combinedObject?.data?.currentApprovalLevel > 0)}
                  />
                </div>
              </div>
            </div>
          </div>}

        {(combinedObject?.activeItem === "Pending Approval" && (combinedObject?.data?.currentApprovalLevel !== 0)) &&
          <div className="result-item" style={{ margin: '10px 0px' }}>
            <span style={{ marginBottom: 5 }}>
              Remarks for Acceptance/ Rejection
            </span>
            <ActionInput
              className="text-input"
              props={{ height: "35px", maxWidth: "250px" }}
              value={remarksTextArea}
              onChange={(e) => setRemarksTextArea(e.target.value)}
            // disabled={ (combinedObject?.data?.currentApprovalLevel > 0)}
            />
          </div>
        }

      </div>
      <div className="analytic-results-buttons result-margin">
        <div className="analytic-results" style={{ width: "30%" }}>
          <ButtonComponent
            type="primary"
            maxWidth="80px"
            label="Back"
            onClick={() => navigate("/analytics-results?fromDetails=true", { state: combinedObject?.landingTitle })}
          />
        </div>
        {role !== "Admin" &&
          <div className="analytic-results-buttons button-alignment">
            {combinedObject?.activeItem === "Pending Approval" && combinedObject?.data?.currentApprovalLevel === 0 && <RejectWorkFlowItem onClickRejectHandler={onClickRejectHandler} disabledRejectButton={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0} />}
            {combinedObject?.activeItem === "Pending Action" && <RejectWorkFlowItem onClickRejectHandler={onClickRejectHandler} disabledRejectButton={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0} />}

            {combinedObject?.data?.ltVariations === "Low" && combinedObject?.activeItem !== "Pending Approval" && combinedObject?.activeItem !== "Closed Workflow Items" &&
              <SendToS4Modal onClickSendToS4Handler={onClickSendToS4Handler} disabledSendToS4Button={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0} />
            }
            {combinedObject?.activeItem === "Pending Action" && <ReAssignModal activeItem={combinedObject?.activeItem} rowCount={[combinedObject?.data]?.length} disableSendForApprovalButton={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0} textAreaValueForSend={remarksTextArea} reAssignSubmitAPI={reAssignSubmitAPI} />}

            {combinedObject?.activeItem === "Pending Action" && <SendForApprovalModal activeItem={combinedObject?.activeItem} rowCount={[combinedObject?.data]?.length} disableSendForApprovalButton={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0} textAreaValueForSend={remarksTextArea} sendForApprovalAPI={sendForApprovalAPI} />}
            {combinedObject?.activeItem === "Pending Approval" && combinedObject?.data?.currentApprovalLevel !== 0 &&
              <ButtonComponent
                maxWidth="200px"
                label="Recall"
                bgColor="Black"
                color="white"
                onClick={RecallAPI}
                disabled={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0}
              />
            }
            {combinedObject?.activeItem === "Pending Approval" && combinedObject?.data?.currentApprovalLevel === 0 &&
              <>
                <EditApproversModalNew runOutputSeqId={combinedObject?.data?.runOutputSeqId} rowCount={[combinedObject?.data]?.length} disableEditApproversButton={combinedObject?.data?.currentApprovalLevel !== 0} editApproversAPI={EditApproversAPI} />
                <ButtonComponent
                  maxWidth="200px"
                  label="Resubmit for Approval"
                  bgColor="Black"
                  color="white"
                  onClick={ResubmitForApprovalAPI}
                  disabled={formData?.LTData?.toString().length === 0 || remarksTextArea?.length === 0 || combinedObject?.data?.currentApprovalLevel !== 0}
                />
              </>}
          </div>
        }
      </div>
      <div>
        <LeadTimeLineGraph openLineGraph={openLineGraph} lineGraphSelectedValue={combinedObject?.data} handleCloseLineGraphModal={handleCloseLineGraphModal} handleSaveModal={handleSaveLineGraphModal} />
      </div>
    </div>
  );
};

export default AnalyticsResultsTab